import { useApolloClient } from '@apollo/client'

import { ScormPackageImportStatusChangedSubscriptionDocument } from 'generated/resources/graphql'

import { useSubscription } from 'modules/core/hooks/useSubscription'

const TERMINAL_STATUSES = ['complete', 'error']

interface UseScormPackageStatusParams {
  scormPackageId?: number | null
  importStatus?: string | null
  skip?: boolean
}

export const useScormPackageStatus = ({
  scormPackageId,
  importStatus,
  skip = false,
}: UseScormPackageStatusParams) => {
  const apolloClient = useApolloClient()

  const isTerminal = !importStatus || TERMINAL_STATUSES.includes(importStatus.toLowerCase())
  const shouldSubscribe = !skip && !!scormPackageId && !isTerminal

  useSubscription(ScormPackageImportStatusChangedSubscriptionDocument, {
    skip: !shouldSubscribe,
    onData: ({ data }) => {
      const updatedPackage = data.data?.trainingsScormPackageImportStatusChanged?.scormPackage
      if (!updatedPackage || Number(updatedPackage.id) !== scormPackageId) return

      apolloClient.cache.modify({
        id: apolloClient.cache.identify({
          __typename: 'TrainingsScormPackage',
          id: Number(updatedPackage.id),
        }),
        fields: {
          importStatus: () => updatedPackage.importStatus,
          title: () => updatedPackage.title ?? null,
          scormVersion: () => updatedPackage.scormVersion ?? null,
          importError: () => updatedPackage.importError ?? null,
        },
      })
    },
  })
}
